import React, { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { parseRedesignHeadingRTF } from '../../util/xhtmlParser.tsx';
import { getBackgroundColor, getTextColorByBgColor } from '../../util/getColorClassName.tsx';
import { SquaresArrow } from '../../components/SquaresArrow.tsx';
const contentVariants = {
    hidden: {
        maxHeight: 0,
        opacity: 0
    },
    visible: {
        maxHeight: '6000px',
        opacity: 1,
        transition: {
            maxHeight: { duration: 0.5 },
            opacity: { duration: 0.5, delay: 0.5 }
        }
    },
    exit: {
        maxHeight: 0,
        opacity: 0,
        transition: {
            maxHeight: { duration: 0.5 },
            opacity: { duration: 0.1, delay: 0.3 }
        }
    }
};
const TabsMobile = ({ items, textColorClass }) => {
    const [currentTab, currentTabSet] = useState(null);
    const toggleItem = (index) => {
        currentTabSet(currentTab === index ? null : index);
    };
    const mobileTabBackgroundColor = 'lightGray';
    const activeMobileClasses = ' text-primary-portsmouthNavy';
    const standardMobileClasses = `${getTextColorByBgColor(mobileTabBackgroundColor)}`;
    return (React.createElement("div", { className: "lg:hidden" },
        React.createElement("dl", null, items?.map((item, index) => (React.createElement(React.Fragment, { key: item.title },
            React.createElement("button", { onClick: () => toggleItem(index), "aria-expanded": currentTab === index, className: "w-full relative cursor-pointer" },
                React.createElement(motion.dt, { className: `transition-all rounded-[10px] duration-300 p-5 mb-[5px] ${getBackgroundColor(mobileTabBackgroundColor)} ${currentTab === index
                        ? activeMobileClasses
                        : standardMobileClasses}  text-left` },
                    React.createElement("p", { className: "text-2xl font-medium max-w-5/6" }, item.title),
                    React.createElement("div", { className: "text-base font-medium max-w-5/6" }, item.description)),
                React.createElement(SquaresArrow, { className: `absolute right-4 top-1/2 -translate-y-1/2 w-[24px] h-[32px] transition-all ${currentTab === index ? '-rotate-90' : 'rotate-90'}` })),
            React.createElement(AnimatePresence, { mode: "wait" }, currentTab === index ? (React.createElement(motion.dd, { key: index, variants: contentVariants, initial: "hidden", animate: "visible", exit: "exit", className: `${currentTab === index
                    ? 'bg-lightGray rounded-b-[10px]'
                    : 'display-none'} text-primary-portsmouthNavy p-5 mb-[5px] -mt-[15px]` },
                React.createElement("div", { className: "faq-content" }, parseRedesignHeadingRTF(item?.tabContent)))) : null)))))));
};
export default TabsMobile;
